"use client";
import { dispatch } from "@store/index";
import { reset } from "@store/reducers/user";
import { deleteToken } from "@util/auth";
import { getLocalStorage, LocalStorageKey } from "@util/storage";
import { Spin } from "antd";
import { redirect } from "next/navigation";
import { useEffect } from "react";

export default function Landing() {
  useEffect(() => {
    const token = getLocalStorage(LocalStorageKey.Token, true);
    if (!token?.accessToken) {
      redirect("/login");
    } else {
      redirect("/admin");
    }
  }, []);

  return (
    <div className="flex flex-1 justify-center items-center h-svh">
      <Spin size="large" />
    </div>
  );
}
